module.exports = __webpack_public_path__ + "img/warning.9480d621.svg";